import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import { routes } from '../../../redux/api/routes';
const { productGEUrl } = routes;

const SortableItem = SortableElement(({handleProductSpec, currentIndex, item, self, availabilities, skuListt}) => {
	const availability = _.find(availabilities, { sku: item.item });
	let data = {
		availableQty: null,
		intransitQty: null,
		etaDate: null,
	};
	if(availability) {
		data = {
			availableQty: availability.availableQty,
			intransitQty: availability.intransitQty,
			etaDate: availability.etaDate,
		};
		if(self.validateFP(availability)) {
			data.intransitQty = null;
			data.etaDate = 'FP';
		} else {
			data = self.validateFDD(availability);
		}
	}
	return <tr key={currentIndex} className={`sortable-tr ${item.selected ? 'selectedRow' : ''}`}>
		<td className="delete">
			<div className="drag-drop"></div>
			<a onClick={(e) => self.handleDelete(item.item, e)} className="deleteLink" href="#">X</a>
		</td>
		<td className="productPhoto">
			{item.imagePath &&
			<a onClick={(e) => self.handleProductSpec(item, currentIndex, data.availableQty, e)} href="">
			<img src={item.imagePath} width={96} height={100} alt={item.itemDescription} title={item.itemDescription} />
			</a>
			}
		</td>
		<td className="product">
			<div className="skuDiv">
				{item.itemType === "S"
					? <span>{item.item}</span>
					: <a href="" onClick={(e) => self.handleProductSpec(item, currentIndex, data.availableQty, e)}>{item.item}</a>
				}
			</div>
			<div className="productNameDiv">{item.itemDescription}</div>
			{item.itemType === "M" && <p className="addAccessories">
				<a className="blueButton" onClick={(e) => self.showAddAccessories(item.item, item.itemDescription, e)} href="">+&nbsp;Accessories</a>
			</p>}
		</td>
		{item.itemType !== "S"
			? <td className="availability txt-ctr">
				<p className={data.availableQty === "0" ? "red" : ""} style={data.availableQty === "0" ? {fontWeight: 'bold'} : {}}>
					{data.availableQty}
				</p>
			</td>
			: <td className="availability txt-ctr">0</td>
		}
		{item.itemType !== "S"
			? <td className="nextavailability txt-ctr">
				<p className={data.availableQty === "0" ? "red" : ""} style={data.availableQty === "0" ? {fontWeight: 'bold'} : {}}>
					{data.intransitQty}
				</p>
			</td>
			: <td className="nextavailability txt-ctr"></td>
		}
		{item.itemType !== "S"
			? <td className="ETA">
				<p className={data.availableQty === "0" ? "red" : ""} style={data.availableQty === "0" ? {fontWeight: 'bold'} : {}}>
					{self.props.formatETADate(data.etaDate)}
				</p>
			</td>
			: <td className="ETA"></td>
		}
		<td className="select">
			<input type="checkbox" onChange={(e) => { self.handleSelect(currentIndex, item.itemType !== "S" ? data.availableQty : null, e) }} checked={item.selected} name="selectedProduct" />
		</td>
	</tr>
});

const SortablePackage = SortableElement(({currentIndex, item, self}) => {
	return <tr className="viperBar" key={currentIndex + 10000}>
		<td className="delete">
			<div className="drag-drop"></div>
			<a className="deleteLink" href="" onClick={(e) => self.handleRemoveAllPackage(item.packageName, e)}>X</a>
		</td>
		<td colSpan="5">
			{item.packageName}
		</td>
		<td className="select">
			<input type="checkbox" name="selectProductsBelow" onChange={(e) => self.handleSelectAllPackage(item, item.packageName, e)} checked={item.packageChecked} />
		</td>
	</tr>
});

const SortableList = SortableContainer(({handleProductSpec, items, self, availabilities, skuListt, classes}) => {
	let packageName = '';
	let count = 0;
	return (
		<tbody className={`sortable ui-sortable user-select-none ${classes}`}>
			{items.map((item, index) => {
				const rows = [];
				if (item.packageName && skuListt.indexOf(item.item) > -1) {
					if (packageName !== item.packageName && (packageName !== '' || count === index)) {
                        count++;
						rows.push(<SortablePackage
							key={`list-package-${count}`}
							item={item}
							self={self}
							currentIndex={count}
							index={count}
						/>)
					}
					packageName = item.packageName;
				}
				rows.push(<SortableItem
					key={`list-item-${count}`}
					item={item}
					self={self}
					currentIndex={index}
					availabilities={availabilities}
					skuListt={skuListt}
					index={index}
					handleProductSpec={handleProductSpec}
				/>);
				count++;
				return rows;
			})}
		</tbody>
	);
});

class SortableComponent extends Component {
	constructor(props) {
        super(props);
		this.state = {
			classes: '',
		};
        this.onSortEnd = this.onSortEnd.bind(this);
		this.shouldCancelStart = this.shouldCancelStart.bind(this);
    }
	onSortEnd({oldIndex, newIndex}) {
		if(oldIndex !== newIndex) {
			const self = this,
				updatedSequenceProducts = arrayMove(self.props.items, oldIndex, newIndex);
			updatedSequenceProducts.forEach((item, index) => {
				item.sequence = index + 1;
			});
			self.props.sortEndOfItems(updatedSequenceProducts);
			self.setState({
				classes: '',
			});
		}
	}
	shouldCancelStart(e) {
		const self = this;
		// Prevent sorting from being triggered if target is input or button
		if (['a', 'button', 'input'].indexOf(e.target.tagName.toLowerCase()) !== -1) {
			self.setState({
				classes: '',
			});
			return true; // Return true to cancel sorting
		} else {
			self.setState({
				classes: 'cursor-move',
			});
		}
    }
	render() {
		return <SortableList
      		items={this.props.items}
			self={this.props.self}
			shouldCancelStart={this.shouldCancelStart}
			availabilities={this.props.availabilities}
			handleProductSpec={this.props.handleProductSpec}
			skuListt={this.props.skuListt}
			onSortEnd={this.onSortEnd}
			classes={this.state.classes}
			helperClass="dragging-helper-class"
			lockAxis="y"
      	/>
	}
}

const mapStateToProps = (state) => {
	return {state};
};

SortableComponent = connect(mapStateToProps)(SortableComponent);
export default SortableComponent;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/List/productSortable.js